<template>
  <div id="contingencia-data">
    <v-layout>
      <!-- lo saque del siguiente campo  @focusout="checkUsername" -->
      <!-- AREA QUE ENTREGA -->
      <v-flex xs12 md6>
        <v-spacer></v-spacer>
        <v-flex xs12>
          <v-text-field
            v-model="username"
            label="Usuario"
            :box="isDisabled"
            :readonly="isDisabled"
            @input="$v.usuario.$touch()"
            @blur="tipeView == 'crear' ? $usuario.$touch() : null"
          ></v-text-field>
        </v-flex>
        <v-select
          v-model="estadoValue"
          :items="estadoSelect"
          item-text="nombre"
          item-value="code"
          label="Estado"
          @input="$v.estadoValue.$touch()"
          @blur="tipeView == 'crear' ? $v.estadoValue.$touch() : null"
          v-if="tipeView == 'crear' ? false : true"
        ></v-select>
        <!-- ADJUNTAR -->
        <data-adjunto
          :documentoId="id"
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto>
        <!-- <v-text-field
          v-model="fichero"
          :error-messages="ficheroErrors"
          label="Adjuntar"
          required
          :readonly="isDisabled"
          @input="$v.fichero.$touch()"
          @blur="tipeView =='crear' ? $v.fichero.$touch() : null"
        ></v-text-field>-->
        <!-- OBSERVACIONES -->
        <v-flex xs12>
          <v-textarea
            v-if="tipeView != 'consulta'"
            v-model="observacion"
            :error-messages="observacionErrors"
            label="Observaciones"
            :readonly="tipeView == 'consulta'"
            :box="tipeView == 'consulta'"
            @input="$v.observacion.$touch()"
            @blur="tipeView == 'crear' ? $v.observacion.$touch() : null"
          ></v-textarea>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        :loading="loading"
        v-if="tipeView == 'modifica' ? false : true"
        color="primary"
        dark
        class="mb-2"
        @click="saveContingencia()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
      <v-btn
        :loading="loading"
        v-if="tipeView == 'modifica'"
        color="primary"
        dark
        class="mb-2"
        @click="editContingencia()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import DataAdjunto from "@/components/AdjuntoData.vue";
import axios from "axios";
export default {
  name: "contingencia-data",
  components: {
    DataAdjunto,
  },
  mixins: [validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      tipoVisitaValue: "",
      allowSpaces: false,
      fecha: new Date().toISOString().substr(0, 10),
      menu1: false,
      codigo: "",
      contratoId: "",
      descripcion: "",
      user: "",
      username: "",
      observacion: "",
      base64Value: "",
      filenameValue: "",
      estadoValue: "",
      estadoSelect: "",
      loading: false,
      tipeArchive: "",
    };
  },

  mixins: [validationMixin],
  validations: {
    filenameValue: { required },
    fecha: { required },
    descripcion: { required },
    estadoValue: { required },
    observacion: { required },
  },

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
    this.proceso = this.$store.getters.subProTabSelectedStored;
    this.tipeView = this.$route.params.tipeView;
    this.user = this.$store.getters.userLogged;
    this.username = this.user.username;
    this.tipeArchive = ".pdf,.doc,.jpg,.png";

    if (this.tipeView == "crear") {
      this.loadData();
    }
    if (this.tipeView == "modifica") {
      this.loadData();
      this.loadDataEstado();
    }
  },
  mounted() {
    //llamar a la api de contratos para listar contratos
  },
  computed: {
    tipoVisitaSelectErrors() {
      const errors = [];
      if (!this.$v.tipoVisitaValue.$dirty) return errors;
      !this.$v.tipoVisitaValue.required && errors.push("Item is required");
      return errors;
    },
    isDisabled() {
      if (this.tipeView && this.tipeView == "crear") {
        return true;
      }
    },
  },
  methods: {
    submit() {
      this.$v.$touch();
    },

    async loadData() {
      this.documento = await this.loadDocumentoData();
      this.estadoValue = this.documento.estadoContingencia;
      this.tipoVisitaSelect = [];

      this.tipoPruebaValue = this.documento.tipoPrueba;
    },

    loadEstado() {
      return axios
        .get(
          "contingencia/" + this.id + "/estado_contingencias/" + this.idContrato
        )
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataEstado() {
      this.dataEstado = await this.loadEstado();
      let tipo = [];
      this.dataEstado.forEach(function (t) {
        tipo.push({
          nombre: t.descripcion,
          code: t.id,
        });
      });
      this.estadoSelect = tipo;
      this.estadoValue = this.estadoSelect;
    },

    editContingencia(e) {
      this.loading = true;
      this.$v.$touch();

      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      let base64EncodedStr = this.base64Value;
      let est = this.estadoValue;
      if (base64EncodedStr == "") {
        this.body = {
          idUserLogged: idUserLogged,
          subProceso: subProceso,
          idContrato: idContrato,
        };
      } else {
        this.body = {
          // idUserLogged: idUserLogged,
          subProceso: subProceso,
          idContrato: idContrato,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          estadoContingencia: { id: est },
          observaciones: this.observacion,
        };
      }
      axios
        .put("contingencia/" + this.id, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
          this.loading = false;
        });
    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },

    loadContratos() {},

    saveContingencia() {
      this.loading = true;
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      let base64EncodedStr = this.base64Value;
      if (base64EncodedStr == "") {
        this.body = {
          // idUserLogged: idUserLogged,
          subProceso: subProceso,
          idContrato: idContrato,
        };
      } else {
        this.body = {
          // idUserLogged: idUserLogged,
          subProceso: subProceso,
          idContrato: idContrato,
          filename: this.filenameValue,
          documento: base64EncodedStr,
          observaciones: this.observacion,
        };
      }
      axios
        .post("/contingencia", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.back();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            this.loading = false;
            console.log(error.response.data.defaultMessage);
          } else if (error) {
            console.log(error.response.data);
            this.loading = false;
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
        });
    },
  },
};
</script>
